var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiSettingsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08595 7.15622C4.22658 6.85934 4.39064 6.57809 4.57814 6.30465L4.54689 4.2734C4.54689 4.0859 4.62502 3.90622 4.77345 3.78122C5.50002 3.17184 6.32814 2.67965 7.2422 2.35153C7.42189 2.28903 7.6172 2.30465 7.77345 2.40622L9.51564 3.45309C9.84377 3.42965 10.1719 3.42965 10.5 3.45309L12.2422 2.40622C12.4063 2.31247 12.6016 2.28903 12.7813 2.35153C13.6719 2.67184 14.5078 3.1484 15.25 3.7734C15.3906 3.89059 15.4766 4.07809 15.4688 4.26559L15.4375 6.29684C15.625 6.57028 15.7891 6.85153 15.9297 7.1484L17.7031 8.13278C17.8672 8.22653 17.9844 8.38278 18.0156 8.57028C18.1797 9.49997 18.1875 10.4687 18.0156 11.414C17.9844 11.6015 17.8672 11.7578 17.7031 11.8515L15.9297 12.8359C15.7891 13.1328 15.625 13.414 15.4375 13.6875L15.4688 15.7187C15.4688 15.9062 15.3906 16.0859 15.2422 16.2109C14.5156 16.8203 13.6875 17.3125 12.7735 17.6406C12.5938 17.7031 12.3985 17.6875 12.2422 17.5859L10.5 16.539C10.1719 16.5625 9.84377 16.5625 9.51564 16.539L7.77345 17.5859C7.60939 17.6797 7.41408 17.7031 7.23439 17.6406C6.34377 17.3203 5.50783 16.8437 4.76564 16.2187C4.62502 16.1015 4.53908 15.914 4.54689 15.7265L4.57814 13.6953C4.39064 13.4218 4.22658 13.1406 4.08595 12.8437L2.31252 11.8593C2.14845 11.7656 2.03127 11.6093 2.00002 11.4218C1.83595 10.4922 1.82814 9.5234 2.00002 8.57809C2.03127 8.39059 2.14845 8.23434 2.31252 8.14059L4.08595 7.15622Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.0711 6.25 10 6.25C7.92893 6.25 6.25 7.92893 6.25 10C6.25 12.0711 7.92893 13.75 10 13.75Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiSettingsFilled);
export default __webpack_public_path__ + "static/media/ci_settings-filled.4624cd5a52eb63d1cc60e7930fc78fc8.svg";
export { ForwardRef as ReactComponent };